/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Filter_SellableInputs */

const vi_product_filter_sellable = /** @type {(inputs: Product_Filter_SellableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bán lẻ`)
};

/**

* @param {Product_Filter_SellableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_filter_sellable = /** @type {((inputs?: Product_Filter_SellableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Filter_SellableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_filter_sellable(inputs)
});